import { createContext } from 'use-context-selector'
import { AdminOrganizationContextProps } from './types'

export const AdminOrganizationContext = createContext(
  {} as AdminOrganizationContextProps
)
